/**
 * Validation for user create/edit endpoints.
 *
 * Roles split by org type — internal viewers can only be created with
 * `ops` or `staff`; client viewers with `client_admin`,
 * `client_submitter`, or `client_viewer`. The route enforces the
 * pairing against the supplied organisationId.
 */

import { z } from 'zod';

import { emailSchema, uuidSchema } from './primitives.js';

const roleSchema = z.enum([
  'ops',
  'staff',
  'client_admin',
  'client_submitter',
  'client_viewer',
]);

export const userCreateInputSchema = z.object({
  organizationId: uuidSchema,
  email: emailSchema,
  name: z.string().min(1).max(200),
  role: roleSchema,
});
export type UserCreateInput = z.infer<typeof userCreateInputSchema>;

/**
 * Update — only name + role are mutable. Email and org are stable
 * (changing email would break inbound-email user lookup; org changes
 * are a re-create.)
 */
export const userUpdateInputSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  role: roleSchema.optional(),
});
export type UserUpdateInput = z.infer<typeof userUpdateInputSchema>;
